// extracted by mini-css-extract-plugin
export default {"form":"basketModal_form__6rDF+","modalContent":"basketModal_modalContent__nDBjn"};